import { useContext } from "react";
import { ZipFileLoadingContext } from "./dashboardContentSection";
import useScreenDimensions from "../hooks/useScreenDimensions";
import { AnimatePresence } from "motion/react";
import * as motion from "motion/react-client";
import { CircularProgress } from "@mui/material";

export const LoadingZipFileModal = () => {
  const { isOpen, setIsOpen } = useContext(ZipFileLoadingContext);
  const { width, height } = useScreenDimensions();

  const cancelEvent = (e: React.MouseEvent) => e.stopPropagation();

  return (
    <AnimatePresence>
      {isOpen ? (
        <motion.div
          key={"campaignModal"}
          style={{
            width,
            height,
            backgroundColor: "rgba(0, 0, 0, .3)",
            position: "fixed",
            zIndex: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            top: 0,
            left: 0,
          }}
          animate={{ opacity: 1 }}
          initial={{ opacity: 0 }}
          exit={{ opacity: 0 }}
        >
          <div
            onClick={cancelEvent}
            style={{
              width: "20rem",
              minWidth: 400,
              backgroundColor: "white",
              padding: 24,
              borderRadius: 16,
              opacity: 1,
              display: "flex",
              flexFlow: "column",
              alignContent: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginTop: '1rem',
                marginBottom: '2rem',
                fontSize: '1.25rem',
                fontWeight: 500
              }}
            >
              We are preparing your zip file
            </div>
            <div style={{display: 'flex', justifyContent: 'center'}}>
            <CircularProgress />
            </div>
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};
